import {Voyage} from "../Process.types";
import {
  ID_TRANSHIPMENT_TYPE_VOYAGE,
  ID_INITIAL_VOYAGE,
  ID_FINAL_DESTINATION_VOYAGE,
  ID_COLLECT_VOYAGE,
} from "./constants";

export const getDestinationVoyageIndex = (voyages: Voyage[]) => {
  const transhipmentVoyages = voyages?.filter(
    (voyage) => voyage?.typeVoyage?.id === ID_TRANSHIPMENT_TYPE_VOYAGE,
  );

  if (transhipmentVoyages?.length) {
    transhipmentVoyages.sort((a, b) => a.precedence - b.precedence);

    const tempVoyages = [...voyages];
    tempVoyages.sort((a, b) => a.precedence - b.precedence);
    const lastTranshipmentVoyageIndex = tempVoyages?.findIndex(
      (item) =>
        item.typeVoyage?.id === ID_TRANSHIPMENT_TYPE_VOYAGE &&
        item?.id === transhipmentVoyages[transhipmentVoyages?.length - 1]?.id,
    );
    return lastTranshipmentVoyageIndex;
  } else {
    const voyageIndex = voyages?.findIndex(
      (voyage) => voyage?.typeVoyage?.id === ID_INITIAL_VOYAGE,
    );
    return voyageIndex;
  }
};

export const getInitialVoyageIndex = (voyages: Voyage[]) => {
  const voyageIndex = voyages?.findIndex(
    (voyage) => voyage?.typeVoyage?.id === ID_INITIAL_VOYAGE,
  );
  return voyageIndex;
};

export const getCollectVoyageIndex = (voyages: Voyage[]) => {
  const voyageIndex = voyages?.findIndex(
    (voyage) => voyage?.typeVoyage?.id === ID_COLLECT_VOYAGE,
  );
  return voyageIndex;
};

export const getFinalDestinationVoyageIndex = (voyages: Voyage[]) => {
  const voyageIndex = voyages?.findIndex(
    (voyage) => voyage?.typeVoyage?.id === ID_FINAL_DESTINATION_VOYAGE,
  );
  return voyageIndex;
};
